import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class IdService {
    /**
     * uuid(8, 2)  //  "01001010"
     * uuid(8, 10) // "47473046"
     * uuid(8, 16) // "098F4D35"
     * @param len çæé¿åº¦
     * @param radix åºæ°
     */
    uuid(len, radix) {
        const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        let uuid = [], i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) {
                uuid[i] = chars[0 | Math.random() * radix];
            }
        } else {
            // rfc4122, version 4 form
            let r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    // tslint:disable-next-line:no-bitwise
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    }

    /**
     * çæçæ ¼å¼ä¸ºâxxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxxâ
     */
    guid() {
        function S4() {
            // tslint:disable-next-line:no-bitwise
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }
}

